import useRouteFeatureStyles from '../hooks/useRouteFeatureStyles';

/** Mount inside BrowserRouter to lazy-load route CSS bundles. */
export default function RouteFeatureStylesLoader(): null {
  useRouteFeatureStyles();
  return null;
}
